import debugging from 'debug'

/** @type {<T>(value: T, workspace?: string) => void} */
export const logToConsole = (value, workspace) => {
  const namespace = workspace ? `provipay:${workspace}` : 'provipay'
  debugging(namespace)(value)
}
